module.exports = __webpack_public_path__ + "static/media/Claydol_gaussian2.7e261149.png";